const data = [
    {
        name:"Cp-Calendar",
        github:"https://github.com/vinayaks0031/CpCalendar-Ext",
        live:"https://microsoftedge.microsoft.com/addons/detail/cpcalendar/iffkianaapnlkhljpldhhphoeljkljjb",
        image:"images/cp.png",
        discription:"A Browser Extension for all the upcoming contests on different competitive programming platforms like Codeforces, Codechef, Leetcode, etc.",
        tech:"Javascript",
        mode:"Download"
    },
    {
        name:"Meanify",
        github:"https://github.com/vinayaks0031/Meanify",
        live:"https://microsoftedge.microsoft.com/addons/detail/meanify/dljdcindnbidjlkapliihhdigmgbbomo",
        image:"images/meanify.png",
        discription:"Meanify is a Browser Extension that helps you to get meanings of unfamiliar words very easily and it also stores them all so you can remember and see them later also.",
        tech:"Javascript",
        mode:"Download"
    },
    {
        name: "College Essentials",
        github: "https://github.com/vinayaks0031/Collage-Essentials",
        live: "https://vm-collagewebsite.netlify.app",
        image: "images/vm.png",
        discription: "College Essentials is a web application where you'll find all the books, syllabus, notes, and previous year exam papers of MCA & BCA.",
        tech: "JavaScript HTML CSS",
        mode:"Live Demo"
    },
    {
        name: "Super Hero Mania",
        github: "https://github.com/vinayaks0031/SuperHero-Mania",
        live: "https://superheromania.netlify.app/",
        image: "images/HeroMania.png",
        discription: "A web app that fetches data from Marvel API and provides you all the data about your favorite superhero (their all versions) and also helps to search marvel comics.",
        tech: "Reactjs",
        mode:"Live Demo"
    },
    {
        name: "News Flash",
        github: "https://github.com/vinayaks0031/NewsFlash",
        live: "https://vm-newsflash.netlify.app/",
        image: "images/DNews.png",
        discription: "A web application that fetches data from API and gives you the top 10 news from your favorite newspaper. ",
        tech: "Javascript",
        mode:"Live Demo"
    }
]

export default data;
